import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const username = 'Esdsd@knsd52841**';
    const password = 'Eoodns@&&**82238417';
    const credentials = btoa(`${username}:${password}`);

    const normalizedUrl = request.url.toLowerCase();
    const isApiRequest = normalizedUrl.includes('/api/') || normalizedUrl.includes('/mobile/');

    if (isApiRequest) {
      request = request.clone({
        setHeaders: {
          Authorization: `Basic ${credentials}`
        }
      });
    }

    return next.handle(request);
  }
}